import React, { useContext, useEffect } from 'react';
import {
	IEditCategoryRestaurantPropertiesContext,
	EditCategoryRestaurantPropertiesContext,
} from '../../../../editCategoryRestaurantPropertiesState/editCategoryRestaurantPropertiesContext';
import { Form } from 'antd';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { RestaurantSelect } from './components/RestaurantSelect';
import { SubcategoryList } from './components/SubcategoryList';
import { ActivationScheduleInput } from './components/ActivationScheduleInput';
import { DeactivationScheduleInput } from './components/DeactivationScheduleInput';
import CronGenerator from 'components/CronGenerator/CronGenerator';
import { BtnBlock } from './components/BtnBlock';
import Text from 'components/Text/Text';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		setIDRestaurant,
		changeActivationSchedule,
		changeDeactivationSchedule,
		setDataForSubmit,
		changeTypeOfModalWindow,
		categoryId,
		categoryName,
		customerName,
		fetchedRestaurants,
		IDSelectedRestaurant,
		subcategories,
		activationSchedule,
		deactivationSchedule,
	} = useContext<IEditCategoryRestaurantPropertiesContext>(EditCategoryRestaurantPropertiesContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			IDSelectedRestaurant,
			activationSchedule,
			deactivationSchedule,
		});
	}, [IDSelectedRestaurant, activationSchedule, deactivationSchedule]);

	const submit = async () => {
		setDataForSubmit({
			categoryId,
			restaurantId: IDSelectedRestaurant || '',
			activationCron: activationSchedule,
			deactivationCron: deactivationSchedule,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const revalidateForm = form.validateFields;

	return (
		<div data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<Text
					className={style.name}
					translationKey={categoryName}
					size="xxl"
					weight="bold"
					display="block"
					withTooltip={true}
				/>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="restaurantPropertiesHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<FullInfoField label="customerLabel" value={customerName} useInForm={true} />
					<RestaurantSelect
						setIDRestaurant={setIDRestaurant}
						fetchedRestaurants={fetchedRestaurants}
						selectedRestaurantId={IDSelectedRestaurant}
					/>
					<SubcategoryList subcategories={subcategories} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<ActivationScheduleInput changeActivationSchedule={changeActivationSchedule} />
						<DeactivationScheduleInput changeDeactivationSchedule={changeDeactivationSchedule} />
					</div>
					<CronGenerator />
				</div>
				<BtnBlock revalidateForm={revalidateForm} />
			</Form>
		</div>
	);
};
